import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, throwError, firstValueFrom } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {
  ITenantReportQueryCriteria,
  IOrder,
  IInvoicePrelimRecipientNotificationDetailsResponse,
  IState,
  ITenantReport,
  IParkerProfileData,
  IAdditionalVehicles,
  IAdditionalEmails,
  IContactShort,
  ILotList,
  IParkerProfileQuery,
  IParkerProfileDetail,
  IParkerProfileUpdateRequest,
  ICompaniesShortList,
  ISpaceEmailUsers,
  ILotRateList,
  IStallTypes,
  IApnSpaceEmailLink,
  ISpaceEmailByEntityId,
  IParkersReadyForactivation,
  IParkerActivationReturnData,
  IParkerMassUpdateCompany,
  IParkerMassUpdateRate,
  IParkerMassUpdateParkerPayType,
  IParkerMassUpdateInvoiceDeliveryMethod,
  IParkerMassUpdate,
  ISettingsState,
  IParkerProfileForParkerTable,
  IParkerProfileImportResult,
  IMarketCompanyRatesByLotNumberWithCompanyId,
  IUniqueMarketRatesForLotNumber,
  IParkerSpaceUpdateCriteria,
  IParkerDeleteSpaceEmailAccount,
  ISpaceDeleteSpaceEmailLink,
  ICompanyDetail,
  ISpaceEmailUsersQueryResult,
  ISpaceEmailQueryForEmailUpdate,
  ILotDisableSpace,
  IInvoiceListWithBalance,
  IInvoiceAdminQueryResults,
  ILotUsageMetrics,
  IApnSpaceRefund,
  IPaymentDeclineTransaction,
  ICompanySearchCriteria,
  ICompanyQueryCriteria,
  ICompanyNew,
  ICompanyUpdate,
  ICompanySpaceEmailLink,
  IParkerCompanyList,
  IAdditionalContact,
  INewAdditionalContact,
  IUpdatedditionalContact,
  IParkersFourUp,
  IUpdateParkerTermDatesByCompany,
  ICompanyExportDetail,
  ICompanySpaceFlagData,
  IAdminAllCompanySearch,
  ICompanyProfileForCompanyTable,
  ICompanyProfileImportResult,
  IParkersNonActiveSpaceAccounts,
  INonActiveAccountResendRequest,
  IParkerAdminSearchResults,
  ILeaseDetail,
  IUploadedDocumentDetail,
  INewLeaseData,
  IUpdateExistingLeaseData,
  ISpaceCompanyAdmin,
  IApnNewSpaceEmailLink,
  IAddNewCompanySpaceEmailLink,
  IApnMassActivationSpaceEmailLink,
  IReportInvoiceAging,
  ILotSpaceMultipleUsers,
  ILotDisableSpaceLotForMultipleUser,
  ILotDisableSpaceEnableMultipleUsers,
  ICompanyActiveStatus,
  IParkerSpaceLotList,
  IAdminInvoiceSearch,
  IParkingAgreementAdminDateHIstory,
  IParkingAgreementAdminRecord,
  IParkingAgreementUpdate,
  ICurrentMasterParkerParkingAgreementDetail,
  ILotParkingAgreementSettingForUpdate,
  ICurrentLotParkingAgreementVerbiage,
  ILotParkerAgreementHistoryVerbiage,
  IParkingAgreementEmailUpdate,
  IParkingAgreementStandardContractUpdate,
  ILotParkingAgreementSpecialInstructionsLink,
  ILotParkingAgreementEmailUpdate,
  ILotParkingAgreementContractVerbiageUpdate,
  IConfigNameValueSetting,
  IUpdateParkingAgreementLotDefaultValues,
  IParkingAgreementTestEmailNotification,
  IParkingAgreementNewParkingAgreementLink,
  IParkingAgreementFetchDetail,
  IParkingAgreementUpdateExemptStatus,
  ILeaseExemptionStatus,
  IAuthenticatedUserStartupData,
  IParkingAgreementReportQueryParams,
  IParkingAgreementReportList,
  IUpdateAgingCommentsOnInvoice,
  IInvoiceAsOfAgingResult,
  IPaymentReportQuery,
  IPaymentReportResult,
  IBuildCompanyInvoiceRequest,
  IBuildParkerInvoiceRequest,
  IPrelimInvoiceListResponse,
  IParkerActiveShortListResponse,
  ICompanyActiveShortListResponse,
  ILotInvoiceMiSettingsResponse,
  IUserListByLotNumberResponse,
  IReportRecurringTasksResponse,
  ISpaceMalFormedListResponse,
  ITaxableListByLotNumberResponse,
  IMiInvoiceDateReadOnlyStatusRequest,
  IMiinvoiceAdjustmentResponse,
  IManualInvoiceNewPrlimWithTax_Request,
  ICardProcessingFeeRequest,
  ICardProcessingFeeResponse,
  IDefaultGbGbCreationPrelimRequest,
  IPrelimInvoiceResponse,
  IGbInvoiceLineItemDescriptionCustomizationResponse,
  IParkerActiveListForInvoiceGeneration,
  IGBFinalizeRequest,
  IGBPrelimFutureRequest,
  IGBPrelimPastRequest,
  IInvoiceSystemGenerationDefaults,
  IInvoiceNotificationDetailsResponse,
  IEntityIdCustomerTypeRequest,
  IEntityIdEmailAdrressResponse,
  IInvoiceGenerationJobResponse,
  IInvoiceGenerationJobStatus,
  IGbInvoiceJobLock,
  ISearchInvoiceDataForInvoiceNotificationRequest,
  ISendInvoiceNotificationResponse,
  ISearchInvoiceDataForComplexInvoiceNotificationRequest,
  IParkerUpdateStatusResponse,
  IAddNewParkerProfileResponse,
  IAmanoParkerDataForCardReassignmentResponse,
  ICredentialTypeResponse,
  IAddtitionalCredentialRespone,
  IAdditionalCredentialNewRequest,
  ICompanyDeleteSpaceEmailAccount,
  IMonitoringReportWebJobsResponse
} from '../../../shared/interfaces';
import { UtilitiesService } from '../helper/utilities.service';
import { environment } from 'src/environments/environment';
import { Contacts } from 'src/app/shared/data/contact';
import { DatePipe } from '@angular/common';
import { InvoiceAdjustments } from 'src/app/shared/entities/InvoiceAdjustments';
import { IAmanoOneAccessHolderUpdateResponse } from 'src/app/shared/code/interfaces/parcs-interfaces';
import {
  IMiInvoiceSubmitRequest,
  Mi_PrelimInvoiceCreationReturn,
} from 'src/app/shared/code/interfaces/mi-invoice-interfaces';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const httpSpaceOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

const httpFileDownloadHttOptions = {
  headers: new HttpHeaders({
    observe: 'response',
    responseType: 'blob',
  }),
};

@Injectable()
export class DataService {
  baseUrl: string = '';
  spaceArEngineBaseUrl: string = '';
  spaceBaseUrl: string = '';
  parkersUrl: string = 'parker';
  adminUrl: string = 'admin';
  ordersUrl: string = 'orders';
  companyUrl: string = 'company';
  spaceUrl: string = 'space';
  userUrl: string = 'user';
  invoiceUrl: string = 'invoice';
  utilityUrl: string = 'utility';
  lotUrl: string = 'lot';
  documentUrl = 'document';
  reportUrl: string = 'report';
  domainListUrl: string = 'domainList';
  orders: IOrder[] = [];
  states: IState[] = [];
  httpOptions: any;

  //Services
  _datePipe = inject(DatePipe);

  constructor(private http: HttpClient) {
    this.baseUrl = environment.RestServer;
    this.spaceBaseUrl = environment.SpaceRestServer;
    this.spaceArEngineBaseUrl = environment.spaceEngineRestServer;
  }

  getMonitoringWebJobsTaskListByStartDate(startDate: string): Observable<IMonitoringReportWebJobsResponse[]> {
    return this.http
      .get<IMonitoringReportWebJobsResponse[]>(`${this.baseUrl}monitoring/job/report/${startDate}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

    // Deletes the space account and manages the Parker table when a spaceAccount is deleted
  deleteCompanySpaceAccount(spaceAccountDeleteData: ICompanyDeleteSpaceEmailAccount): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}${this.spaceUrl}/account/company/delete/${spaceAccountDeleteData.emailAddress}/${spaceAccountDeleteData.spaceUserId}/${spaceAccountDeleteData.companyId}/${spaceAccountDeleteData.spaceEmailId}`,httpOptions)
      .pipe(catchError(this.handleError));
  }


  // Deletes the space account and manages the Parker table when a spaceAccount is deleted
  deleteParkerSpaceAccount(spaceAccountDeleteData: IParkerDeleteSpaceEmailAccount): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}${this.spaceUrl}/account/parker/delete/${spaceAccountDeleteData.emailAddress}/${spaceAccountDeleteData.spaceUserId}/${spaceAccountDeleteData.parkerId}/${spaceAccountDeleteData.spaceEmailId}`,httpOptions)
      .pipe(catchError(this.handleError));
  }

  /// Deletes an existing Additional Credential for a given AdditionalCredentiaId
  additionalCredentialDeleteExistingCredential(additionalCredentialId: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}parker/additionalcredentials/${additionalCredentialId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  /// Adds a new Additional Credential for a Parker Id
  additionalCredentialAddNewCredential(queryData: IAdditionalCredentialNewRequest): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}parker/additionalcredential `, queryData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  /// Gets a list of Additional Credentials for a Parker Id
  getAdditionalCredentialListForAParkerId(parkerId: string): Observable<IAddtitionalCredentialRespone[]> {
    return this.http
      .get<IAddtitionalCredentialRespone[]>(`${this.baseUrl}parker/additionalCredentialList/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a list of credential types for a given lot number
  getCredentialTypeListForAGivenLotNumber(lotNumber: string): Observable<ICredentialTypeResponse[]> {
    return this.http
      .get<ICredentialTypeResponse[]>(`${this.baseUrl}parker/credentialtypelist/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets the Amano One Parker Data needed for card reassignment for a given access holder id.
  getAmanoOneParkerDataForCardReassignment(
    accessHolderId: string,
  ): Observable<IAmanoParkerDataForCardReassignmentResponse> {
    return this.http
      .get<IAmanoParkerDataForCardReassignmentResponse>(
        `${this.baseUrl}parcs/accessholder/cardreassignment/${accessHolderId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Gets the access holder id for a given lot number and card number.
  // Returns a valid accessHolderId if found.  Error thrown if doesn't exist
  getAmanoOneAccessHolderforCardNumberLotNumber(lotNumber: string, cardNumber: string): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}parcs/lot/account/exists/${lotNumber}/${cardNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets the access holder id for a given lot number and card number.
  // Returns a valid accessHolderId if found.  Error thrown if doesn't exist
  getAmanoOneAccessHolderforCardNumberLotNumberForUpdate(
    parkerId: string,
    lotNumber: string,
    cardNumber: string,
  ): Observable<string> {
    return this.http
      .get<string>(
        `${this.baseUrl}parcs/lot/account/existsforupdate/${parkerId}/${lotNumber}/${cardNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Gets a list of invoices used for sending invoice email notifications
  // This searches by multiple data types and is a complex query with multiple criteria
  getInvoiceDataForInvoiceNotificationsByComplexQuery(
    queryData: ISearchInvoiceDataForComplexInvoiceNotificationRequest,
  ): Observable<ISendInvoiceNotificationResponse[]> {
    const queryString = this.PrepInvoiceComplexQuerySearchCriteriaRequest(queryData);

    return this.http
      .get<
        ISendInvoiceNotificationResponse[]
      >(`${this.baseUrl}invoice/notifications/search/complex?${queryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a list of invoices used for sending invoice email notifications.
  // This query primarily filters invoices based on lot number and the type of balance.
  getInvoiceDataForInvoiceNotificationsByBalanceAndTypeQuery(
    queryData: ISearchInvoiceDataForInvoiceNotificationRequest,
  ): Observable<ISendInvoiceNotificationResponse[]> {
    return this.http
      .post<
        ISendInvoiceNotificationResponse[]
      >(`${this.baseUrl}invoice/notifications/search/currentbalance`, queryData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Get the sender email address for a given lot number
  getSenderEmailAddressForLot(lotNumber: string): Observable<string | null> {
    return this.http
      .get<string | null>(`${this.baseUrl}lot/senderemailaddress/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Get the sender email address for a given lot number, used for populating the from field on invoice notification emails
  getInvoiceSenderEmailAddressForLot(lotNumber: string): Observable<string | null> {
    return this.http
      .get<string | null>(`${this.baseUrl}lot/invoicesenderemailaddress/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Create GB Default Prelim Invoices - replaced with new submit/polling code
  GenerateGbDefaultPreliminaryInvoices(
    invoiceData: IDefaultGbGbCreationPrelimRequest,
  ): Observable<IInvoiceGenerationJobResponse> {
    return this.http
      .post<IInvoiceGenerationJobResponse>(
        `${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/default`,
        invoiceData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  GetInvoiceGenerationJobStatus(jobId: string): Observable<IInvoiceGenerationJobStatus> {
    return this.http
      .get<IInvoiceGenerationJobStatus>(
        `${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/default/status/${jobId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  GetActiveGbInvoiceJobs(): Observable<IGbInvoiceJobLock[]> {
    return this.http
      .get<IGbInvoiceJobLock[]>(`${this.spaceArEngineBaseUrl}invoice/admin/gb-invoice-jobs`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ReleaseGbInvoiceJobLock(lockId: string): Observable<void> {
    return this.http
      .delete<void>(`${this.spaceArEngineBaseUrl}invoice/admin/gb-invoice-jobs/${lockId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a list of emailAddresses for a given list of entity IDs with customer types
  getMatchingEmailAddressesListForParker(
    entityIdList: IEntityIdCustomerTypeRequest[],
  ): Observable<IEntityIdEmailAdrressResponse[]> {
    return this.http
      .request<IEntityIdEmailAdrressResponse[]>('POST', `${this.baseUrl}parker/emailaddressforentityidlist`, {
        body: entityIdList,
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleError));
  }

  // Updates the date sent when a given invoice is sent via email to a customer
  updateInvoiceNotificationEmailDateSent(invoiceNumber: string, dateSent: string): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.spaceArEngineBaseUrl}invoice/notification/updatesenddate/${invoiceNumber}/${dateSent}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Gets the email address, if it exists assocated with the customer for a given prelim invoice number.
  getPrelimInvoiceCustomerEmailAddress(invoiceNumber: string): Observable<string> {
    return this.http
      .get<string>(`${this.spaceArEngineBaseUrl}invoice/notification/prelimcustomeremail/${invoiceNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets details needed for sending an invoice notification email.
  getInvoiceDetailsForInvoiceNotificationEmail(invoiceNumber: string): Observable<IInvoiceNotificationDetailsResponse> {
    return this.http
      .get<IInvoiceNotificationDetailsResponse>(
        `${this.spaceArEngineBaseUrl}invoice/notification/getsenddetails/${invoiceNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Gets details needed for sending an invoice notification email for a prelim invoice, including the recipient email address and delivery method (email vs physical mail)
  getPrelimInvoiceDetailsForRecipientNotificationEmail(
    invoiceNumber: string,
  ): Observable<IInvoicePrelimRecipientNotificationDetailsResponse> {
    return this.http
      .get<IInvoicePrelimRecipientNotificationDetailsResponse>(
        `${this.spaceArEngineBaseUrl}invoice/notification/prelim/recipientemaildetails/${invoiceNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Sends an invoice notification email to the recipient email address with details about the invoice such as due date, customer name, etc
  // Used to send an email notification after an invoice is finalized, and can also be used to resend the notification email if needed
  sendInvoiceNotificationEmail(invoiceNumber: string): Observable<boolean> {
    return this.http
      .post(`${this.spaceArEngineBaseUrl}invoice/notifications/invoice/send/${invoiceNumber}`, null, {
        responseType: 'text' as const,
      })
      .pipe(map((response: string) => response.toLowerCase() === 'true'))
      .pipe(catchError(this.handleError));
  }

  // Sends an invoice notification email to the recipient email address with details about the invoice such as due date, customer name, etc
  // Used to send an email notification after an invoice is finalized, and can also be used to resend the notification email if needed
  // This includes user comments which will be appended to the outbound smtp email message.
  sendInvoiceNotificationEmailWithComments(invoiceNumber: string, comments: string): Observable<boolean> {
    return this.http
      .post(
        `${this.spaceArEngineBaseUrl}invoice/notifications/invoice/sendwithuserdata/${invoiceNumber}`,
        JSON.stringify(comments),
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          responseType: 'text' as const,
        },
      )
      .pipe(map((response: string) => response.trim().toLowerCase() === 'true'))
      .pipe(catchError(this.handleError));
  }

  // Gets the system defaults for setting date system defaults when creating new MI/GB prelim invoices
  invoiceCreation_GetSystemDefaults(lotNumber: string): Observable<IInvoiceSystemGenerationDefaults> {
    return this.http
      .get<IInvoiceSystemGenerationDefaults>(`${this.baseUrl}invoice/systemdefaults/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a new invoice number for a new Manual Invoice
  mi_InvoiceNumber_GetNewInvoiceNumber(lotNumber: string, invoiceDate: string): Observable<string> {
    return this.http
      .get(`${this.spaceArEngineBaseUrl}invoice/mi/newinvoicenumber/${lotNumber}/${invoiceDate}`, {
        responseType: 'text',
      })
      .pipe(catchError(this.handleError));
  }

  async mi_InvoiceNumber_GetNewInvoiceNumberSync(lotNumber: string, invoiceDate: string): Promise<string> {
    return await firstValueFrom(this.mi_InvoiceNumber_GetNewInvoiceNumber(lotNumber, invoiceDate));
  }

  // Generates a prelim MI Invoice. The server assigns the invoice number and returns it; do not
  // generate one client-side, because a collision makes the server pick a different number.
  mi_GeneratePrelimInvoices(
    invoiceGenerationCriteria: IMiInvoiceSubmitRequest,
  ): Observable<Mi_PrelimInvoiceCreationReturn> {
    return this.http
      .post<
        Mi_PrelimInvoiceCreationReturn
      >(`${this.spaceArEngineBaseUrl}invoice/mi/createprelim`, invoiceGenerationCriteria, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Geenrates a GB Prelim Invoice for multiple past months based on the provided criteria
  gb_GeneratePrelimInvoiceForPastMonths(
    invoiceGenerationCriteria: IGBPrelimPastRequest,
  ): Observable<IInvoiceGenerationJobResponse> {
    return this.http
      .post<
        IInvoiceGenerationJobResponse
      >(`${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/multimonth/past`, invoiceGenerationCriteria, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Creates prelim GB Invoices for one or more future months.
  gb_GeneratePrelimInvoiceForFutureMonths(
    invoiceGenerationCriteria: IGBPrelimFutureRequest,
  ): Observable<IInvoiceGenerationJobResponse> {
    return this.http
      .post<
        IInvoiceGenerationJobResponse
      >(`${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/multimonth/future`, invoiceGenerationCriteria, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Finalizes a prelim GB Invoice
  gb_FinalizePrelimInvoice(invoiceToFinalize: IGBFinalizeRequest): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.spaceArEngineBaseUrl}invoice/gb/finalize`, invoiceToFinalize, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Finalizes a prelim MI Invoice
  mi_FinalizePrelimInvoice(invoiceNumber: string, lotNumber: string): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.spaceArEngineBaseUrl}invoice/mi/finalize/${invoiceNumber}/${lotNumber}`, null, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets an list of active parkers when creating mult-month future or past prelim invoices
  getActiveParkerListByCompanyIdForPastMonths(
    companyId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<IParkerActiveListForInvoiceGeneration[]> {
    const formattedStartDate: string = this._datePipe.transform(startDate, 'yyyy-MM-dd') ?? '';
    const encodedStartDate: string = encodeURIComponent(formattedStartDate);
    const formattedEndDate: string = this._datePipe.transform(endDate, 'yyyy-MM-dd') ?? '';
    const encodedEndDate: string = encodeURIComponent(formattedEndDate);

    return this.http
      .get<
        IParkerActiveListForInvoiceGeneration[]
      >(`${this.baseUrl}parker/multimonthpast/activeparkercheck/${companyId}/${encodedStartDate}/${encodedEndDate}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets an list of active parkers when creating mult-month future or past prelim invoices
  getActiveParkerListByCompanyIdForFutureMonths(
    companyId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<IParkerActiveListForInvoiceGeneration[]> {
    const formattedStartDate: string = this._datePipe.transform(startDate, 'yyyy-MM-dd') ?? '';
    const encodedStartDate: string = encodeURIComponent(formattedStartDate);
    const formattedEndDate: string = this._datePipe.transform(endDate, 'yyyy-MM-dd') ?? '';
    const encodedEndDate: string = encodeURIComponent(formattedEndDate);

    return this.http
      .get<
        IParkerActiveListForInvoiceGeneration[]
      >(`${this.baseUrl}parker/multimonthfuture/activeparkercheck/${companyId}/${encodedStartDate}/${encodedEndDate}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetsLotListInvoiceLineItemDescriptionStatus(): Observable<IGbInvoiceLineItemDescriptionCustomizationResponse[]> {
    return this.http
      .get<
        IGbInvoiceLineItemDescriptionCustomizationResponse[]
      >(`${this.baseUrl}lot/setup/invoicecustomizablelist`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Sets the status of whether GB Invoice Line Description Customization is enabled or disabled for a given lot number
  SetLotGbLineItemCustomizationStatus(lotNumber: string, isCutomizable: boolean): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}lot/setup/invoicelinecustomizablestatus/${lotNumber}/${isCutomizable}`,
        null,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Gets the status of whether GB Invoice Line Description Customization is enabled or disabled for a given lot number
  GetGbInvoiceLineItemDescriptionStatusForLotNumber(lotNumber: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}lot/setup/invoicelinecustomizablestatus/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets the PDF for a given GB invoice number and lot number, returns as a blob for download
  GetGbInvoicePdf(invoiceNumber: string, lotNumber: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${this.spaceArEngineBaseUrl}invoice/invoicepdfgb/${lotNumber}/${invoiceNumber}`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  // Gets the PDF for a given MI invoice number and lot number, returns as a blob for download
  GetMiInvoicePdf(invoiceNumber: string, lotNumber: string, entityId: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${this.spaceArEngineBaseUrl}invoice/invoicepdfmi/${lotNumber}/${entityId}/${invoiceNumber}`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  // Generates prelim GB Default invoices configuration data for a given lot number and invoice date
  // GenerateGbDefaultPreliminaryInvoices(
  //   invoiceData: IDefaultGbGbCreationPrelimRequest,
  // ): Observable<IPrelimInvoiceResponse[]> {
  //   return this.http
  //     .post<
  //       IPrelimInvoiceResponse[]
  //     >(`${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/default`, invoiceData, httpOptions)
  //     .pipe(catchError(this.handleError));
  // }

  // Replaced with new submit/polling code
  //
  GenerateGbDefaultPreliminaryInvoicesWithCancelSupport(
    invoiceData: IDefaultGbGbCreationPrelimRequest,
    abortSignal: AbortSignal,
  ): Observable<IPrelimInvoiceResponse[]> {
    const httpOptionsWithSignal = {
      ...httpOptions,
      signal: abortSignal,
    };

    return this.http
      .post<
        IPrelimInvoiceResponse[]
      >(`${this.spaceArEngineBaseUrl}invoice/generate/gb/prelim/default`, invoiceData, httpOptionsWithSignal)
      .pipe(catchError(this.handleError));
  }

  // Gets the card processing enabled status and fee percentage for a given lot number
  GetCardProcessingFeeSettingsForLot(lotNumber: string): Observable<ICardProcessingFeeResponse> {
    return this.http
      .get<ICardProcessingFeeResponse>(`${this.baseUrl}lot/cardprocessingfee/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Sets the card processing enabled status and fee percentage for a given lot number
  SetLotCardProcessingValues(
    lotNumber: string,
    cardProcessingSettingValues: ICardProcessingFeeRequest,
  ): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}lot/cardprocessingfee/${lotNumber}`, cardProcessingSettingValues, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a vehicle that is designated as the primary vehicle for a given parkerId
  // A primary vehicle is the first/oldest vehicle that is added for a given Parker
  GetPrimaryVehicleForParkerId(parkerId: string): Observable<IAdditionalVehicles> {
    return this.http
      .get<IAdditionalVehicles>(`${this.baseUrl}${this.parkersUrl}/vehicles/primary/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Updates Parker table first, last name for a given parkerId
  updateParkerFirstLastNameCardNumber(
    parkerId: string,
    firstName: string,
    lastName: string,
    cardNumber: string,
  ): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}parker/syncupdate/${parkerId}/${firstName}/${lastName}/${cardNumber}`,
        null,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  getAmanoOneParcsTrackingAccessHolder(
    lotNumber: string,
    cardNumber: string,
  ): Observable<IAmanoOneAccessHolderUpdateResponse> {
    return this.http
      .get<IAmanoOneAccessHolderUpdateResponse>(
        `${this.baseUrl}parker/parcs/amano/trackingaccessholder/${lotNumber}/${cardNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  getAmanoOneParcsCardNumber(lotNumber: string, cardNumber: string): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}parker/parcs/amano/cardnumberexists/${lotNumber}/${cardNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceUserIdbyParkerId(parkerId: string): Observable<number> {
    return this.http
      .get<number>(`${this.baseUrl}space/spaceuserid/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postPrelimManualInvoice(manualInvoiceData: IManualInvoiceNewPrlimWithTax_Request): Observable<null> {
    return this.http
      .post<null>(`${this.baseUrl}invoice/manualinvoice/newprelimtax`, manualInvoiceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getNextInvoiceNumberForManualInvoice(lotNumber: string): Observable<number> {
    return this.http
      .get<number>(`${this.baseUrl}invoice/newinvoicesequencenumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMiInvoiceAdjustmentData(invoiceNumber: string): Observable<IMiinvoiceAdjustmentResponse> {
    return this.http
      .get<IMiinvoiceAdjustmentResponse>(`${this.baseUrl}invoice/miadjustmentdetails/${invoiceNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMiInvoiceBillingLines(invoiceNumber: string): Observable<InvoiceAdjustments[]> {
    return this.http
      .get<InvoiceAdjustments[]>(`${this.baseUrl}invoice/miinvoicebillinglines/${invoiceNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  setMiInvoiceDateReadOnlyStatus(updateData: IMiInvoiceDateReadOnlyStatusRequest): Observable<void> {
    return this.http
      .put<void>(`${this.baseUrl}admin/setinvoicedatereadonlystatus`, updateData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMiInvoiceDateReadOnlyStatus(lotNumber: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}admin/miinvoicedatedreadonlystatus/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMiRevenueCodeForLitenItem(billingDetailId: string): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}invoice/mirevenuecode/${billingDetailId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getGBRevenueCodeForLitenItem(lineItemId: string): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}invoice/gbrevenuecode/${lineItemId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getIsTaxableListForLot(lotNumber: string): Observable<ITaxableListByLotNumberResponse[]> {
    return this.http
      .get<ITaxableListByLotNumberResponse[]>(`${this.baseUrl}invoice/taxablebylot/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  fixAllMalformedSpaceAccounts(): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}space/FixAllMalformedSpaceAccounts`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets all data for recurring automated tasks
  getSpaceMalformedAccounts(): Observable<ISpaceMalFormedListResponse[]> {
    return this.http
      .get<ISpaceMalFormedListResponse[]>(`${this.baseUrl}space/GetMalformedSpaceAccounts`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets all data for recurring automated tasks
  getReportAutomatedTasksSummaryData(taskName: string): Observable<IReportRecurringTasksResponse[]> {
    return this.http
      .get<IReportRecurringTasksResponse[]>(`${this.baseUrl}report/recurringtask/${taskName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets a list of users for a given lot number
  getUserLitByLotNumber(lotNumber: string): Observable<IUserListByLotNumberResponse[]> {
    return this.http
      .get<IUserListByLotNumberResponse[]>(`${this.baseUrl}lot/${lotNumber}/userList`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Gets the settings that are used in creating MI Invoices
  getLotMiInvoiceSettings(lotNumber: string): Observable<ILotInvoiceMiSettingsResponse> {
    return this.http
      .get<ILotInvoiceMiSettingsResponse>(`${this.baseUrl}lot/GetLotMiInvoiceSettings/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets a list of active parkes for a given lot number - parkerId, lastname, firstname
  getCompanyActiveShortListByLotNumber(lotNumber: string): Observable<ICompanyActiveShortListResponse[]> {
    return this.http
      .get<
        ICompanyActiveShortListResponse[]
      >(`${this.baseUrl}company/getactivecompanyaddressphonelist/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets a list of active parkes for a given lot number - parkerId, lastname, firstname
  getParkerActiveShortListByLotNumber(lotNumber: string): Observable<IParkerActiveShortListResponse[]> {
    return this.http
      .get<
        IParkerActiveShortListResponse[]
      >(`${this.baseUrl}parker/getactiveparkerlistforlotnumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  logFinalizedInvoice(invoiceNumber: string): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}invoice/UpdateInvoiceFinalization/${invoiceNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Transitions a newly created prelim invoice from prelim to finalized state
  updateInvoiceStatusToFinalized(lotNumber: string, invoiceNumber: string): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}invoice/UpdateInvoiceCreationFromPrelimtoFinal/${lotNumber}/${invoiceNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Returns a list of invoices that have been created for preliminary review
  getCompanyParkerPrelimInvoiceList(lotNumber: string): Observable<IPrelimInvoiceListResponse[]> {
    return this.http
      .get<
        IPrelimInvoiceListResponse[]
      >(`${this.baseUrl}invoice/GetCompanyParkerPrelimInvoiceList/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Generates the prelim invoices for parkers
  createParkerPrelimInvoices(invoiceData: IBuildParkerInvoiceRequest): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}invoice/CreateParkerPrelimInvoices`, invoiceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Generates the prelim invoices for companies
  createCompanyPrelimInvoices(invoiceData: IBuildCompanyInvoiceRequest): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}invoice/CreateCompanyPrelimInvoices`, invoiceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets status on whether any invoices (GB or MI) are ready/need to be generated.  If all finalized then returns false
  getStatusAreAllInvoiceFinalized(lotNumber: string, invoiceDate: string, dueDate: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}invoice/GetStatusInvoicesNeedToBeGenerated/${lotNumber}/${invoiceDate}/${dueDate}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //During the invoice prelim creation process, this removes any existing MI Invoice Prelims previously generated
  deleteExistingMiPrelimInvoices(lotNumber: string): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}invoice/DeleteExistingPreliminaryInvoices/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //During the invoice prelim creation process, this removes any existing GB Invoice Prelims previously generated
  deleteExistingGbPrelimInvoices(lotNumber: string): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}invoice/DeleteExistingPreliminaryManualInvoices/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }
  //Gets data for the payment report with lotNumber, optional from/to date, paymentCode and tenantName (parker first/last or company name)
  getReportPaymentData(queryData: IPaymentReportQuery): Observable<IPaymentReportResult[]> {
    // const companyId: string = queryData.companyId == '' ? 'NULL' : queryData.companyId;

    var dateFromString: string = this._datePipe.transform(queryData.fromDate, 'MM/dd/yyyy') ?? '';
    var dateToString: string = this._datePipe.transform(queryData.toDate, 'MM/dd/yyyy') ?? '';

    return this.http
      .get<IPaymentReportResult[]>(
        `${this.baseUrl}report/ReportGetPaymentReport?lotNumber=${queryData.lotNumber}&fromDate=${dateFromString}&toDate=${dateToString}
          &tenantName=${queryData.tenantName}&paymentTypeId=${queryData.paymentTypeId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets data for the tenant report with lotNumber, asOfDate and optional companyId
  getTenantRosterData(queryData: ITenantReportQueryCriteria): Observable<ITenantReport[]> {
    const companyId: string = queryData.companyId == '' ? 'NULL' : queryData.companyId;

    return this.http
      .get<
        ITenantReport[]
      >(`${this.baseUrl}report/ReportGetTenantRoster?lotNumber=${queryData.lotNumber}&asOfDate=${queryData.asOfDate.toDateString()}&companyId=${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets data for the aging report with an as of date
  getAsOfAgingReport(lotNumber: string, asOfDate: string): Observable<IInvoiceAsOfAgingResult[]> {
    return this.http
      .get<
        IInvoiceAsOfAgingResult[]
      >(`${this.baseUrl}report/ReportAsOfAgingReport?lotNumber=${lotNumber}&asOfDate=${asOfDate}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Updates comments on invoice status table (g_searchResults) for a given invoice number
  updateInvoiceAgingComments(commentData: IUpdateAgingCommentsOnInvoice): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}Invoice/UpdateInvoiceAgingComments`, commentData, httpOptions)
      .pipe(catchError(this.handleError))
      .pipe(catchError(this.handleError));
  }

  getParkingAgreementReportList(queryString: string): Observable<IParkingAgreementReportList[]> {
    return this.http
      .get<
        IParkingAgreementReportList[]
      >(`${this.baseUrl}parker/GetParkingAgreementReportList?${queryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets the data necessary for a user to perform startup sequence for a previously authenticated UserId
  getAuthenticatedUserStartupDate(userId: string): Observable<IAuthenticatedUserStartupData> {
    return this.http
      .get<IAuthenticatedUserStartupData>(`${this.baseUrl}credential/GetAuthenticatedUserData/${userId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Updates the lease exemption status by companyId
  updateLeaseExempStatus(leaseExemptStatus: ILeaseExemptionStatus): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}Company/UpdateLeaseExemptStatus`, leaseExemptStatus, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Initiates an email notification to a parker (parkerId) with an attachment of the signed Monthly Parking Agreement
  parkingAgreementResendExecutedContract(parkerId: string): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.spaceArEngineBaseUrl}ParkingAgreement/ParkingAgreementResendSignedContract/${parkerId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Truncates the Parking Agreement table - available only on DEV
  resetParkingAgreementTable(): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}${this.parkersUrl}/ResetParkingAgreementData`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  updateParkingAgreementExemptStatus(exemptUpdate: IParkingAgreementUpdateExemptStatus): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.parkersUrl}/UpdateParkingAgreeExemptStatus`, exemptUpdate, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets the parking agreement data for a given parkerId
  getParkingAgreementDetailByParkerId(parkerId: string): Observable<IParkingAgreementFetchDetail> {
    return this.http
      .get<IParkingAgreementFetchDetail>(
        `${this.baseUrl}${this.parkersUrl}/ParkingAgreementGetDetailByParkerIdWithLocalDateTimes/${parkerId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  sendParkingAgreementNotification(notificationData: IParkingAgreementNewParkingAgreementLink): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}${this.parkersUrl}/ParkingAgreementLinkNotification`, notificationData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  sendTestParkingAgreementNotification(notificationData: IParkingAgreementTestEmailNotification): Observable<any> {
    return this.http
      .get<any>(
        `${this.baseUrl}${this.parkersUrl}/SendTestParkerAgreementEmail/${notificationData.recipientEmailAddress}/${notificationData.lotNumber}/${notificationData.lotName}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  UpdateLogParkingAgreementDefaultValues(defaultValues: IUpdateParkingAgreementLotDefaultValues): Observable<any> {
    return this.http
      .put<any>(
        `${this.baseUrl}${this.lotUrl}/UpdateDefaultValueSettingsForLotParkingAgreementTemplate`,
        defaultValues,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  UpdateConfigValueSetting(configSetting: IConfigNameValueSetting): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}${this.domainListUrl}/UpdateSpaceArSetting`, configSetting, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets a confiig value setting for a given config value name
  GetConfigValueSetting(settingName: string): Observable<IConfigNameValueSetting> {
    return this.http
      .get<IConfigNameValueSetting>(
        `${this.baseUrl}${this.domainListUrl}/GetSpaceArSettingValue/${settingName}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Updates Lot Specific Parking Agreeement Data of the Contract Verbiage - for specific lot number
  UpdateLotParkingAgreementContractVerbiage(
    contractVerbiageData: ILotParkingAgreementContractVerbiageUpdate,
  ): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}${this.lotUrl}/UpdateLotParkingAgreementContractVerbiage`,
        contractVerbiageData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Updates Lot Specific Parking Agreement Data for Email Subject and Email Body - for specific lot number
  UpdateLotParkingAgreementEMailSettings(linkDataForLot: ILotParkingAgreementEmailUpdate): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.lotUrl}/UpdateLotParkingAgreementEMailSettings`, linkDataForLot, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Updates Lot Specific Parking Agreement Data for Special Instructions Url - for specific lot number
  UpdateLotParkingAgreementUrlLink(linkDataForLot: ILotParkingAgreementSpecialInstructionsLink): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.lotUrl}/UpdateLotParkingAgreementUrlLink`, linkDataForLot, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Update Parking Agreement Standard Contract Template
  UpdateParkingAgreementStandardContractAgreement(
    contractStandardAgreement: IParkingAgreementStandardContractUpdate,
  ): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}${this.parkersUrl}/UpdateParkingAgreementTemplateStandardContractSection`,
        contractStandardAgreement,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Update Parking Agreement Email Subject, Email Body Template
  UpdateParkingAgreementEmailTemplate(emailData: IParkingAgreementEmailUpdate): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}${this.parkersUrl}/UpdateParkingAgreementTemplateEmailSettings`,
        emailData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  UpdateLotParkingPrimaryEmail(parkerId: string, emailAddress: string): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}${this.parkersUrl}/UpdateParkerPrimaryEmail/${parkerId}/${emailAddress}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets a list of historical parking agreement setting entries
  GetHistoryParkingAgreementVerbiageForLot(lotNumber: string): Observable<ILotParkerAgreementHistoryVerbiage[]> {
    return this.http
      .get<
        ILotParkerAgreementHistoryVerbiage[]
      >(`${this.baseUrl}${this.lotUrl}/GetListOfParkerAgreementEntriesbyLotNumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Gets the parking agreement data for a given lot number
  GetParkingAgreementVerbiageForLot(lotNumber: string): Observable<ICurrentLotParkingAgreementVerbiage> {
    return this.http
      .get<ICurrentLotParkingAgreementVerbiage>(
        `${this.baseUrl}${this.lotUrl}/GetCurrentParkingAgreementVerbiageForLot/${lotNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets the current master template for parking agreement
  GetLotParkingAgreementVerbiageData(): Observable<ICurrentMasterParkerParkingAgreementDetail> {
    return this.http
      .get<ICurrentMasterParkerParkingAgreementDetail>(
        `${this.baseUrl}${this.parkersUrl}/GetParkingCurrentTemplateData`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets the current master template for parking agreement
  GetMasterParkingAgreementTemplateDetail(): Observable<ICurrentMasterParkerParkingAgreementDetail> {
    return this.http
      .get<ICurrentMasterParkerParkingAgreementDetail>(
        `${this.baseUrl}${this.parkersUrl}/GetParkingCurrentTemplateData`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Updates the lot specific parking agreement template
  //In process of updating data, creates a historical archive of the current data before update
  UpdateLotParkingAgreementVerbiage(lotAgreementData: ILotParkingAgreementSettingForUpdate): Observable<number> {
    return this.http
      .put<number>(
        `${this.baseUrl}${this.lotUrl}/ParkingAgreementUpdateAdminTemplateData`,
        lotAgreementData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Updates the admin parking agreement template
  //In process of updating data, creates a historical archive of the current data before update
  UpdateParkingAgreementStandardAdminTemplate(templateTrackingId: IParkingAgreementUpdate): Observable<number> {
    return this.http
      .put<number>(
        `${this.baseUrl}${this.parkersUrl}/ParkingAgreementUpdateAdminTemplateData`,
        templateTrackingId,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // GetParkingAgreementAdminHistoryEntry
  // Returns one entry of type IParkingAgreementAdminRecord(TemplateTrackingId, ParkerAgreementStandardTemplate, EmailSubject, EmailBody, DateStart, DateEnd) of Parking Agreement template data
  GetParkingAgreementHistoryEntry(templateTrackingId: string): Observable<IParkingAgreementAdminRecord> {
    return this.http
      .get<IParkingAgreementAdminRecord>(
        `${this.baseUrl}${this.parkersUrl}/GetParkerParkingAgreementAdminTemplateData/${templateTrackingId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // GetParkingAgreementAdminRevisionDateHistory
  // Returns list of type IParkingAgreementAdminDateHIstory(TemplateTrackingId, DateStart, DateEnd) for the revision history of Parking Agreement template data
  GetParkingAgreementAdminHistoryR(): Observable<IParkingAgreementAdminDateHIstory[]> {
    return this.http
      .get<
        IParkingAgreementAdminDateHIstory[]
      >(`${this.baseUrl}${this.parkersUrl}/GetParkerAgreementAdminTemplateDateRevisionHistory`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // DeleteSpaceArInvoicePayment
  // Deletes one invoice payment on an invoice
  // Returns True/False
  DeleteSpaceArInvoicePayment(invoicePaymentId: string, invoiceNumber: string, userName: string): Observable<boolean> {
    return this.http
      .delete<boolean>(
        `${this.baseUrl}${this.adminUrl}/AdminDeleteInvoicePayment/${invoicePaymentId}/${invoiceNumber}/${userName}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // DeleteSpaceArInvoice
  // Deletes one invoice number
  // Returns True/False
  DeleteSpaceArInvoice(invoiceNumber: string, userName: string): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}${this.adminUrl}/AdminDeleteInvoice/${invoiceNumber}/${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //GetParkerOrCompanyPayTypeFromSpaceAccount
  //Gets the parker or company pay type for a registered space email account.
  //return values
  // -1 - space account not located for this email address
  // 0 - parker pay type
  // 1 - company pay type
  // 2 - both parker and company pay types exist - this is an error
  // 3 - an invalid pay type was found for the entityid type
  GetParkerOrCompanyPayTypeFromSpaceAccount(
    emailAddress: string,
    entityId: string,
    spaceUserId: number,
  ): Observable<number> {
    return this.http
      .get<number>(
        `${this.baseUrl}${this.spaceUrl}/GetParkerOrCompanPaidTypeForSpaceEmailAddress/${emailAddress}/${spaceUserId}/${entityId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  IsThisUserASuperUser(userName: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}${this.userUrl}/IsUserSuperUser/${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IsParkerPaidEmailAvailable(emailAddress: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.spaceUrl}/IsEmailAvailableForNewParkerPaidAccount?emailaddress=${emailAddress}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets an object with a list of lots that have the given email assigned.
  IsCompanyPaidEmailAvailableOnLot(emailAddress: string, lotNumber: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.spaceUrl}/IsCompanyPaidEmailAvailableOnLot?emailaddress=${emailAddress}&lotNumber=${lotNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Gets an object with a list of lots that have the given email assigned.
  getParkerSpaceEmailAssociatedLotList(emailAddress: string): Observable<IParkerSpaceLotList> {
    return this.http
      .get<IParkerSpaceLotList>(
        `${this.baseUrl}${this.spaceUrl}/GetLotListOfParkerSpaceEmailAccountsForEmailAddress?emailaddress=${emailAddress}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  GetCompanyNewSpaceEmailAddressIsValidForNewAccount(
    emailAddress: string,
    lotNumber: string,
  ): Observable<ICompanyActiveStatus[]> {
    return this.http
      .get<
        ICompanyActiveStatus[]
      >(`${this.baseUrl}${this.spaceUrl}/GetCompaniesAssociatedWithSpaceEmail/${emailAddress}/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Returns list of companies and active status that are registered with space and have the same email address and lot number
  getCompaniesWithSameRegisteredSpaceEmailAddress(
    emailAddress: string,
    lotNumber: string,
  ): Observable<ICompanyActiveStatus[]> {
    return this.http
      .get<
        ICompanyActiveStatus[]
      >(`${this.baseUrl}${this.companyUrl}/GetCompaniesAssociatedWithSpaceEmail/${emailAddress}/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Returns status of whether a company can add more than one instance of the same spaceuser within the same lot
  getSpaceUserMultiUserEnabledStatusForLot(lotNumber: string): Observable<number> {
    return this.http
      .get<number>(`${this.baseUrl}${this.lotUrl}/GetLotSpaceMultipleUserStatus/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Sets status of a lot that specifies whether the same space user can be added more than once within the same lot
  UpdateSpaceSetMultipleUserStatus(updateSettings: ILotDisableSpaceEnableMultipleUsers): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.lotUrl}/UpdateSpaceMultipleUsersStatus`, updateSettings, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Returns an array of objects that contains lot data which has a flag set to true,
  //which enables the same spACE user to be assigned to multiple companies within the same lot number
  getLotsEnabledForMultipleSpaceUsers(): Observable<ILotSpaceMultipleUsers[]> {
    return this.http
      .get<ILotSpaceMultipleUsers[]>(`${this.baseUrl}${this.lotUrl}/GetLotsSpaceEnabledForMultipleUsers`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAllLotsAdminSpaceMultipleLots(): Observable<ILotSpaceMultipleUsers[]> {
    return this.http
      .get<ILotSpaceMultipleUsers[]>(`${this.baseUrl}${this.lotUrl}/GetAllLotsAdminSpaceUserMultipleLots`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getReportInvoiceAging(lotNumber: string): Observable<IReportInvoiceAging[]> {
    return this.http.get<IReportInvoiceAging[]>(
      `${this.baseUrl}${this.reportUrl}/reportgetinvoiceaging/${lotNumber}`,
      httpOptions,
    );
  }

  getLanaiInitSettings(): Observable<any> {
    try {
      return this.http.get<any>(`${this.baseUrl}credential/lanaisettinginit`, httpOptions);
    } catch (err) {
      console.error('error calling lanaiinitsettings', err);
      return throwError(() => err);
    }
  }

  getCompanySpaceAdminProfileList(emailAddress: string): Observable<ISpaceCompanyAdmin[]> {
    return this.http.get<ISpaceCompanyAdmin[]>(
      `${this.baseUrl}${this.adminUrl}/getcompanylinkedspaceemail/${emailAddress}`,
      httpOptions,
    );
  }

  updateLeaseData(leaseData: IUpdateExistingLeaseData) {
    return this.http.put<ILeaseDetail>(
      `${this.baseUrl}${this.companyUrl}/updateexistingcompanylease`,
      leaseData,
      httpOptions,
    );
  }

  restoreDeletedDocument(documentId: string, userName: string) {
    return this.http.put<any>(
      `${this.baseUrl}${this.documentUrl}/restoredeleteddocumentdtatus/${documentId}/${userName}`,
      null,
      httpOptions,
    );
  }

  updateDocumentDeleteStatus(documentId: string, deleteStatus: boolean, userName: string) {
    return this.http.put<any>(
      `${this.baseUrl}${this.documentUrl}/updatedocumentdeletedstatus/${documentId}/${deleteStatus}/${userName}`,
      null,
      httpOptions,
    );
  }

  getLeaseIdDocumentForDownload(documentId: string) {
    return this.http.get<string>(
      `${this.baseUrl}${this.documentUrl}/getleasedocumentfordownload/${documentId}`,
      httpOptions,
    );
  }

  getLeaseIdForCompany(companyId: string, lotNumber: string) {
    return this.http.get<number>(
      `${this.baseUrl}${this.companyUrl}/getleaseidforcompany/${lotNumber}${companyId}`,
      httpOptions,
    );
  }

  getLeaseDocument(leaseDocumentId: string) {
    return this.http.get<Blob>(
      `${this.baseUrl}${this.documentUrl}/getleasedocument/${leaseDocumentId}`,
      httpFileDownloadHttOptions,
    );
  }

  public download(documentId: string) {
    return this.http
      .get(`${this.baseUrl}${this.documentUrl}/getleasedocument/${documentId}`, httpFileDownloadHttOptions)
      .pipe(catchError(this.handleError));
  }

  postNewLease(apnSpaceRefund: INewLeaseData): Observable<ILeaseDetail> {
    return this.http
      .post<ILeaseDetail>(`${this.baseUrl}${this.companyUrl}/postnewcompanylease`, apnSpaceRefund, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getLeaseDocumentsByCompanyId(companyId: string): Observable<IUploadedDocumentDetail[]> {
    return this.http
      .get<IUploadedDocumentDetail[]>(`${this.baseUrl}${this.documentUrl}/getleasedocuments/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getDeletedLeaseDocumentsByCompanyId(companyId: string): Observable<IUploadedDocumentDetail[]> {
    return this.http
      .get<
        IUploadedDocumentDetail[]
      >(`${this.baseUrl}${this.documentUrl}/getdeletedleasedocuments/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getLeaseByCompanyIdLotNumber(lotNumber: string, companyId: string): Observable<ILeaseDetail> {
    return this.http
      .get<ILeaseDetail>(`${this.baseUrl}${this.companyUrl}/getleaseforcompany/${lotNumber}/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkerAdminByFirstLastName(preparedQueryString: string): Observable<IParkerAdminSearchResults[]> {
    return this.http
      .get<
        IParkerAdminSearchResults[]
      >(`${this.baseUrl}${this.adminUrl}/getparkerdatabyfirstorlastname?${preparedQueryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkerAdminByEmailOrLicensePlate(
    searchCriteria: string,
    includeInactive: boolean,
    includeInActiveLots: boolean,
  ): Observable<IParkerAdminSearchResults[]> {
    return this.http
      .get<
        IParkerAdminSearchResults[]
      >(`${this.baseUrl}${this.adminUrl}/getparkerdatabyemaillicenseplate/${searchCriteria}/${includeInactive}/${includeInActiveLots}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  IsCompanyNameAvilableForLot(lotNumber: string, companyName: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.companyUrl}/iscompanyavailableforlot/${lotNumber}/${companyName}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  PostCompanyImport(companyImportData: ICompanyProfileForCompanyTable[]): Observable<ICompanyProfileImportResult[]> {
    return this.http
      .post<
        ICompanyProfileImportResult[]
      >(`${this.baseUrl}${this.companyUrl}/postnewcompanyprofileimport`, companyImportData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAdminAllLotCompanySearch(companyName: string): Observable<IAdminAllCompanySearch[]> {
    return this.http
      .get<
        IAdminAllCompanySearch[]
      >(`${this.baseUrl}${this.companyUrl}/getadmincompanylistbycompanyname/${companyName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateCompanySpaceFlags(companyPortalData: ICompanySpaceFlagData): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.companyUrl}/updatecompanyspaceportalflags`, companyPortalData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  updateSpaceCompanyEmailAccountByEmailAddress(
    emailAddress: string,
    spaceUserId: number,
    spaceEmailId: number,
  ): Observable<number> {
    return this.http
      .get<number>(
        `${this.baseUrl}${this.spaceUrl}/UpdateSpaceEmailCompanyAccountEmailAddress/${emailAddress}/${spaceUserId}/${spaceEmailId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  GetAdminMassActivationLotList(): Observable<ILotList[]> {
    return this.http
      .get<ILotList[]>(`${this.baseUrl}${this.adminUrl}/getadminlotlistformassactivation`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetNumberOfAddiitonalVehiclesForParker(parkerId: string): Observable<number> {
    return this.http
      .get<number>(`${this.baseUrl}${this.parkersUrl}/getnumberofadditionalvehiclesforparker/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetLotUsageMetricsForCompany(lotNumber: string, companyId: string): Observable<ILotUsageMetrics[]> {
    return this.http
      .get<
        ILotUsageMetrics[]
      >(`${this.baseUrl}${this.lotUrl}/getlotusagemetricsforcompany/${lotNumber}/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetLotMarketCompanyUsageMetrics(lotNumber: string): Observable<ILotUsageMetrics[]> {
    return this.http
      .get<
        ILotUsageMetrics[]
      >(`${this.baseUrl}${this.lotUrl}/getlotusagemetricsformarketcompany/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetLotUsageMetrics(lotNumber: string): Observable<ILotUsageMetrics[]> {
    return this.http
      .get<ILotUsageMetrics[]>(`${this.baseUrl}${this.lotUrl}/getlotusagemetrics/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateParkerTermDateByCompanyIdNewTermDate(termData: IUpdateParkerTermDatesByCompany): Observable<number> {
    return this.http
      .put<number>(`${this.baseUrl}${this.parkersUrl}/updateparkertermdataforcompany`, termData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetNumberOfActiveParkersForCompany(companyId: string): Observable<number> {
    return this.http
      .get<number>(`${this.baseUrl}${this.parkersUrl}/getnumberofactiveparkersforcompany/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkerDetailByParkerId(parkerId: string): Observable<IParkerProfileDetail> {
    return this.http
      .get<IParkerProfileDetail>(`${this.baseUrl}${this.parkersUrl}/getparkerdetail/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetParkersForCompanyFourUp(companyId: string): Observable<IParkersFourUp[]> {
    return this.http
      .get<
        IParkersFourUp[]
      >(`${this.baseUrl}${this.parkersUrl}/getparkerlistforcompanyfourup/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateCompanySetSpacePortalOff(companyId: string): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.spaceUrl}/spacedeactivatecompanyportaluser/${companyId}`, null, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteCompanyAdditionalContact(additionalContactId: number): Observable<boolean> {
    return this.http
      .delete<boolean>(
        `${this.baseUrl}${this.companyUrl}/deletecompanyadditionalcontact/${additionalContactId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  UpdateCompanyAdditionalContactByAdditionalContactId(companyData: IUpdatedditionalContact): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.companyUrl}/updatecompanyadditionalcontact`, companyData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postCompanyNewAdditionalContact(contactData: INewAdditionalContact): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}${this.companyUrl}/postnewcompanyadditionalcontact`, contactData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteCompanySpaceEmailBySpaceEmailId(spaceEmailId: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.baseUrl}${this.spaceUrl}/deletecompanyspaceemail/${spaceEmailId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAdditionalContactsForCompany(companyId: string): Observable<IAdditionalContact[]> {
    return this.http
      .get<
        IAdditionalContact[]
      >(`${this.baseUrl}${this.companyUrl}/getcompanyadditionalcontactsbycompanyid/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetParkerListForCompany(companyId: string): Observable<IParkerCompanyList[]> {
    return this.http
      .get<IParkerCompanyList[]>(`${this.baseUrl}${this.parkersUrl}/getparkerlistforcompany/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyProfileByCompanyId(companyId: string): Observable<ICompanyDetail> {
    return this.http
      .get<ICompanyDetail>(`${this.baseUrl}${this.companyUrl}/getcompanyprofilebycompanyid/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetIsSpaceCompanyEmailTaken(emailAddress: string, entityId: string, lotNumber: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.spaceUrl}/getspaceiscompanyemailtaken?emailaddress=${emailAddress}&entityid=${entityId}}&lotNumber=${lotNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  postCompanySpaceEmailLink(companySpaceData: IAddNewCompanySpaceEmailLink): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}${this.spaceUrl}/postcompanyspaceemailaccount`, companySpaceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateCompanyDetailByCompanyId(companyData: ICompanyUpdate, lotNumber: string): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.companyUrl}/updateexistingcompany/${lotNumber}`, companyData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyExistsForLotNumber(companyName: string, lotNumber: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.companyUrl}/getcompanyexistsforlotnumber?companyname=${companyName}&lotnumber=${lotNumber}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  GetCompanyDetailByCompanyId(companyId: string): Observable<ICompanyDetail> {
    return this.http
      .get<ICompanyDetail>(`${this.baseUrl}${this.companyUrl}/getcompanydetail/${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyExportProfilesBySearchCriteria(queryData: ICompanyQueryCriteria): Observable<ICompanyExportDetail[]> {
    let queryString: string = this.PrepGetCompanyQueryString(queryData);

    return this.http
      .get<
        ICompanyExportDetail[]
      >(`${this.baseUrl}${this.companyUrl}/getcompaniesexportprofilebyquerycriteria?${queryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyProfilesBySearchCriteria(queryData: ICompanyQueryCriteria): Observable<ICompanyDetail[]> {
    let queryString: string = this.PrepGetCompanyQueryString(queryData);

    return this.http
      .get<
        ICompanyDetail[]
      >(`${this.baseUrl}${this.companyUrl}/GetCompaniesProfilesByQueryCriteria?${queryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  PostNewCompany(newCompanyData: ICompanyNew): Observable<ICompanyDetail> {
    return this.http
      .post<ICompanyDetail>(`${this.baseUrl}${this.companyUrl}/postnewcompanyprofile`, newCompanyData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postApnSpaceRefund(apnSpaceRefund: IApnSpaceRefund[]): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.baseUrl}${this.spaceUrl}/AddSpaceRefundFromApn`, apnSpaceRefund, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdatePaymentToDeclineStatus(invoiceDeclineData: IPaymentDeclineTransaction): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.baseUrl}${this.spaceUrl}/updateinvoicepaymenttodeclinestatus`,
        invoiceDeclineData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //Refactor
  //20240705 :: Ken Moss
  //Changed name from GetAdminInvoiceListByEntitIyd to GetAdminInvoiceListByQueryCriteria
  //Added invoiceNumber to query string
  GetAdminInvoiceListByQueryCriteria(searchCriteria: IAdminInvoiceSearch): Observable<IInvoiceAdminQueryResults[]> {
    return this.http
      .get<
        IInvoiceAdminQueryResults[]
      >(`${this.baseUrl}${this.adminUrl}/getadmininvoicedatabyentityid?entityId=${searchCriteria.entityId}&emailAddress=${searchCriteria.emailAddress}&spaceUserId=${searchCriteria.spaceUserId}&invoiceNumber=${searchCriteria.invoiceNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetSqlServerGuid(): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}${this.utilityUrl}/getguid`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetSqlServerGuidFiveSecondDelay(): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}${this.utilityUrl}/getguidfiveseconddelay`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetInvoiceListByEntityIdWithBalance(entityId: string): Observable<IInvoiceListWithBalance[]> {
    return this.http
      .get<
        IInvoiceListWithBalance[]
      >(`${this.baseUrl}${this.invoiceUrl}/GetInvoiceListByEntityIdWithBalance/?entityId=${entityId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateSpaceDisable(updateSettings: ILotDisableSpace): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.lotUrl}/UpdateSpaceDisable`, updateSettings, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAllLotsAdminSpaceDisable(): Observable<ILotDisableSpace[]> {
    return this.http
      .get<ILotDisableSpace[]>(`${this.baseUrl}${this.lotUrl}/getalllotsforspacedisableadmin`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getDisableSpaceList(): Observable<ILotDisableSpace[]> {
    return this.http
      .get<ILotDisableSpace[]>(`${this.baseUrl}${this.lotUrl}/GetDisableSpaceLotList`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceEmailAccountsForSpaceEmailUpdate(
    queryCriteria: ISpaceEmailQueryForEmailUpdate,
  ): Observable<ISpaceEmailUsersQueryResult[]> {
    return this.http
      .get<
        ISpaceEmailUsersQueryResult[]
      >(`${this.baseUrl}${this.spaceUrl}/GetSpaceEmailAccountsBySpaceEmailCriteria/${queryCriteria.spaceEmailAddress}/${queryCriteria.spaceUserId}/${queryCriteria.spaceEntityId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyProfileListByLotNumber(lotNumber: string): Observable<ICompanyDetail[]> {
    return this.http
      .get<
        ICompanyDetail[]
      >(`${this.baseUrl}${this.companyUrl}/getcompanyprofilelistbylotnumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCurrentQueryDownload(): Observable<ISettingsState> {
    return this.http
      .get<ISettingsState>(`${this.baseUrl}${this.parkersUrl}/GetCurrentQueryDownload`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceEmailAccountsByEmailAddress(emailAddress: string): Observable<ISpaceEmailUsersQueryResult[]> {
    return this.http
      .get<
        ISpaceEmailUsersQueryResult[]
      >(`${this.baseUrl}${this.spaceUrl}/GetSpaceEmailAccountsByEmailAddress/${emailAddress}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  //Updates a SpaceUser Email Address by the SpaceEmailId
  //Revised 20240702 by Ken MOss
  //Added SpaceEmailId as the key for updating spaceemail, instead of previous endpoint which updated by EmailAddress
  updateSpaceEmailAccountByEmailAddress(
    emailAddress: string,
    spaceUserId: number,
    spaceEmailId: number,
  ): Observable<number> {
    return this.http
      .get<number>(
        `${this.baseUrl}${this.spaceUrl}/updateSpaceEmailAccountEmailAddress/${emailAddress}/${spaceUserId}/${spaceEmailId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  updateAdminParkerSettings(updateSettings: IParkerSpaceUpdateCriteria): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.adminUrl}/parkerupdatesettings`, updateSettings, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdminAllSettingsStateValues(): Observable<ISettingsState> {
    return this.http
      .get<ISettingsState>(`${this.baseUrl}${this.adminUrl}/getsettingstatevalues`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  updateAdminPaymentOverrideSetting(settingValue: boolean): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.adminUrl}/updatepaymentoverride`, settingValue, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdminParkerProfileListByParkerIdSpaceEmailAddress(
    parkerId: string,
    spaceEmailAddress: string,
    spaceUserId: string,
  ): Observable<IParkerProfileDetail[]> {
    return this.http
      .get<
        IParkerProfileDetail[]
      >(`${this.baseUrl}${this.adminUrl}/getparkerlistbyparkeridspaceemail?parkerId=${parkerId}&spaceemailaddress=${spaceEmailAddress}&spaceUserId=${spaceUserId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdminParkerProfileDetailByParkerId(parkerId: string): Observable<IParkerProfileDetail> {
    return this.http
      .get<IParkerProfileDetail>(`${this.baseUrl}${this.adminUrl}/getParkerDetail?parkerId=${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceEmailUsersByEntityId(entityId: string): Observable<ISpaceEmailUsers[]> {
    return this.http
      .get<
        ISpaceEmailUsers[]
      >(`${this.baseUrl}${this.spaceUrl}/GetSpaceEmailsByEntityId?entityId=${entityId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAllActiveMarketCompanyRatesByLotNumberWithCompanyId(
    lotNumber: string,
  ): Observable<IMarketCompanyRatesByLotNumberWithCompanyId[]> {
    return this.http
      .get<
        IMarketCompanyRatesByLotNumberWithCompanyId[]
      >(`${this.baseUrl}${this.lotUrl}/GetMarketAndCompanyRatesForLotNumberWithCompanyId?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUniqueMarketRatesByLotNumber(lotNumber: string): Observable<ILotRateList[]> {
    return this.http
      .get<
        ILotRateList[]
      >(`${this.baseUrl}${this.lotUrl}/GetUniqueMarketRatesByLotNumber?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMarketRatesForLotNumber(lotNumber: string): Observable<ILotRateList[]> {
    return this.http
      .get<ILotRateList[]>(`${this.baseUrl}${this.lotUrl}/GetMarketRatesForLot?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getLotStallDescriptionList(lotNumber: string): Observable<IStallTypes[]> {
    return this.http
      .get<
        IStallTypes[]
      >(`${this.baseUrl}${this.lotUrl}/GetLotStallDescriptionsByLotNumber?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMarketCompanyRatesForLotAndCompany(lotNumber: string, companyId: string): Observable<ILotRateList[]> {
    return this.http
      .get<
        ILotRateList[]
      >(`${this.baseUrl}${this.lotUrl}/GetMarketAndCompanyRatesForLotAndCompany?lotNumber=${lotNumber}&companyId=${companyId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getMarketCompanyRatesForLotNumber(lotNumber: string): Observable<ILotRateList[]> {
    return this.http
      .get<
        ILotRateList[]
      >(`${this.baseUrl}${this.lotUrl}/GetMarketAndCompanyRatesForLotNumber?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getCompanySpaceUnRestrictedLostListByUserName(userName: string): Observable<ILotList[]> {
    return this.http
      .get<
        ILotList[]
      >(`${this.baseUrl}${this.lotUrl}/getnonspacerestrictedlotsbyusermame?userName=${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getActiveLostListByUserName(userName: string): Observable<ILotList[]> {
    return this.http
      .get<ILotList[]>(`${this.baseUrl}${this.lotUrl}/GetLotsByUserName?userName=${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getCurrentDefaultLotForUser(userName: string): Observable<string> {
    return this.http
      .get<string>(`${this.baseUrl}${this.lotUrl}/GetDefaultLotForUser?userName=${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceUsersByLotNumber(lotNumber: String): Observable<ISpaceEmailUsers[]> {
    return this.http
      .get<
        ISpaceEmailUsers[]
      >(`${this.baseUrl}${this.parkersUrl}/getspaceEmailsByLotNumber?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkersExpiredRatesByLotNumber(lotNumber: String): Observable<IParkerProfileDetail[]> {
    return this.http
      .get<
        IParkerProfileDetail[]
      >(`${this.baseUrl}${this.parkersUrl}/GetParkerExpiredRatesForLot?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetParkersDuplicateKeyCardNumbersForLot(lotNumber: String): Observable<IParkerProfileDetail[]> {
    return this.http
      .get<
        IParkerProfileDetail[]
      >(`${this.baseUrl}${this.parkersUrl}/GetParkerDuplicateKeyCardNumbersForLot?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkerListByQueryCriteria(queryData: IParkerProfileQuery): Observable<IParkerProfileDetail[]> {
    //let testQueryData: IParkerProfileQuery = this.prepSampleQueryData();
    let queryString: string = this.prepGetParkersQueryString(queryData);

    //queryString = 'lotNumber=1410';
    return this.http
      .get<
        IParkerProfileDetail[]
      >(`${this.baseUrl}${this.parkersUrl}/getparkerlistforquerycriteria?${queryString}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdditionalVehiclesForParker(parkerId: string): Observable<IAdditionalVehicles[]> {
    return this.http
      .get<IAdditionalVehicles[]>(`${this.baseUrl}${this.parkersUrl}/vehicles/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdditionalEmailsForParker(parkerId: string): Observable<IAdditionalEmails[]> {
    return this.http
      .get<IAdditionalEmails[]>(`${this.baseUrl}${this.parkersUrl}/GetParkerAdditionalEmails/${parkerId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdditionalVehiclesForLotNumber(lotNumber: string): Observable<IAdditionalVehicles[]> {
    return this.http
      .get<
        IAdditionalVehicles[]
      >(`${this.baseUrl}${this.parkersUrl}/GetParkerAdditionalVehiclesByLotNumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getAdditionalEmailsForLotNumber(lotNumber: string): Observable<IAdditionalEmails[]> {
    return this.http
      .get<
        IAdditionalEmails[]
      >(`${this.baseUrl}${this.parkersUrl}/GetParkerAdditionalEmailsByLotNumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getCompanyListForLotNumber(lotNumber: string): Observable<ICompaniesShortList[]> {
    return this.http
      .get<ICompaniesShortList[]>(`${this.baseUrl}${this.companyUrl}/GetCompaniesByLotNumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCompanyListActiveAndInActiveForLotNumber(lotNumber: string): Observable<ICompanySearchCriteria[]> {
    return this.http
      .get<
        ICompanySearchCriteria[]
      >(`${this.baseUrl}${this.companyUrl}/GetCompaniesActiveAndInActiveByLotNumber/${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postNewParkerProfile(parkerData: IParkerProfileDetail): Observable<IAddNewParkerProfileResponse> {
    return this.http
      .post<IAddNewParkerProfileResponse>(`${this.baseUrl}${this.parkersUrl}/AddNewParkerProfile`, parkerData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  /** @deprecated Use postNewParkerProfile with parcsType='AmanoOne' and the amanoOne payload object. Kept as a fallback until the unified endpoint is confirmed. */
  postNewParkerProfileAmanoOne(
    parkerData: IParkerProfileDetail,
    accessGroupId: string,
    credentialTypeId: string,
    credentialSystemCode: string,
    reassignCardNumber: boolean,
  ): Observable<number> {
    return this.http
      .post<number>(
        `${this.baseUrl}${this.parkersUrl}/new/amano/${accessGroupId}/${credentialTypeId}/${credentialSystemCode}/${reassignCardNumber}`,
        parkerData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  // Updates existing Parker Profile and PARCS if necessary
  // 20260919 :: Ken Moss - Switched the payload from IParkerProfileDetail to the dedicated
  // IParkerProfileUpdateRequest DTO so only the fields the endpoint reads go over the wire.
  updateExistingParkerProfile(
    parkerData: IParkerProfileUpdateRequest,
    reassignCardNumber: boolean,
  ): Observable<IParkerUpdateStatusResponse> {
    return this.http
      .put<IParkerUpdateStatusResponse>(
        `${this.baseUrl}${this.parkersUrl}/updateprofile/${reassignCardNumber}`,
        parkerData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  postAdditionalEmailforParker(emailData: IAdditionalEmails): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}${this.parkersUrl}/AddNewAdditionalEmailAddress`, emailData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postAdditionalVehicleforParker(vehicleData: IAdditionalVehicles, lotNumber: string): Observable<IAdditionalVehicles> {
    return this.http
      .post<IAdditionalVehicles>(
        `${this.baseUrl}${this.parkersUrl}/AddNewAdditionalParkerVehicle/${lotNumber}`,
        vehicleData,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  updateAdditionalEmailforParker(emailData: IAdditionalEmails): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.parkersUrl}/UpdateExistingAdditionalEmail`, emailData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  deleteAdditionalEmailforParker(additionalEmailId: number): Observable<boolean> {
    return this.http
      .delete<boolean>(
        `${this.baseUrl}${this.parkersUrl}/DeleteExistingAdditionalEmail/${additionalEmailId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  //not in use
  deleteSpaceAccountBySpaceEmailId(spaceAccountDeleteData: ISpaceDeleteSpaceEmailLink): Observable<boolean> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .delete<boolean>(
        `${this.baseUrl}${this.spaceUrl}/deletespaceemailaccountbyspaceuserid/${spaceAccountDeleteData.entityId}/${spaceAccountDeleteData.emailAddress}${spaceAccountDeleteData.spaceEmailId}`,
        options,
      )
      .pipe(catchError(this.handleError));
  }



  deleteAdditionalVehicleforParker(vehicleId: number, userName: string): Observable<boolean> {
    return this.http
      .delete<boolean>(
        `${this.baseUrl}${this.parkersUrl}/DeleteExistingAdditionalVehicle/${vehicleId}/${userName}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  updateAdditionalVehicleForParker(parkerData: IAdditionalVehicles): Observable<boolean> {
    return this.http
      .put<boolean>(`${this.baseUrl}${this.parkersUrl}/UpdateExistingAdditionalVehicle`, parkerData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postApnSpaceEmailLink(apnSpaceData: IApnNewSpaceEmailLink): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}${this.spaceUrl}/SpaceApnNewSpaceEmail`, apnSpaceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceUserApnEmailResend(emailAddress: string, userId: string, lastDateEmailResend: string): Observable<number> {
    return this.http
      .get<number>(
        `${this.baseUrl}${this.spaceUrl}/getSpaceUserApnEmailResend?emailAddress=${emailAddress}&userId=${userId}&lastDateEmailResend=${lastDateEmailResend}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  getSpaceUserIdForEmailAddress(
    emailAddress: string,
    sendEmail: number,
    entityIdType: number,
    entityId: string,
  ): Observable<number> {
    return this.http
      .get<number>(
        `${this.baseUrl}${this.spaceUrl}/GetSpaceUserIdForEmailAddress/${emailAddress}/${sendEmail}/${entityIdType}/${entityId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  getSpaceEmailAddressByEntityId(entityId: string): Observable<ISpaceEmailByEntityId[]> {
    return this.http
      .get<
        ISpaceEmailByEntityId[]
      >(`${this.baseUrl}${this.spaceUrl}/getspaceemailaddressbyentityid/${entityId}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSpaceEmailAddressByParkerId(parkerId: string): Observable<ISpaceEmailByEntityId> {
    return this.http
      .get<ISpaceEmailByEntityId>(
        `${this.baseUrl}${this.parkersUrl}/GetSpaceEmailAddressByParkerId/${parkerId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  /// Does this key card number exist for a given Lot Number and active Parkers.
  getKeyCardExistsByLotNumberCardNumber(lotNumber: string, cardNumber: string, parkerId: string): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.baseUrl}${this.parkersUrl}/GetKeyCardExistsForLotNumberCardNumber?lotNumber=${lotNumber}&cardNumber=${cardNumber}&parkerId=${parkerId}`,
        httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  getIsUserAdmin(userName: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}${this.userUrl}/isUserAdmin?userName=${userName}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkersReadyForActivationByLotNumber(lotNumber: string): Observable<IParkersReadyForactivation[]> {
    return this.http
      .get<
        IParkersReadyForactivation[]
      >(`${this.baseUrl}${this.parkersUrl}/getParkersReadyForActivation?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getParkersNonActiveSpaceAccountsByLotNumber(lotNumber: string): Observable<IParkersNonActiveSpaceAccounts[]> {
    return this.http
      .get<
        IParkersNonActiveSpaceAccounts[]
      >(`${this.baseUrl}${this.parkersUrl}/getparkersnonactivespaceaccounts?lotNumber=${lotNumber}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postParkerActivateSpaceAccount(
    apnSpaceData: IApnMassActivationSpaceEmailLink[],
  ): Observable<IParkerActivationReturnData[]> {
    return this.http
      .post<
        IParkerActivationReturnData[]
      >(`${this.baseUrl}${this.parkersUrl}/ParkerActivateSpaceUser`, apnSpaceData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postParkerResendSpaceNonActiveAccounts(
    resendAccountData: INonActiveAccountResendRequest[],
  ): Observable<IParkerActivationReturnData[]> {
    return this.http
      .post<
        IParkerActivationReturnData[]
      >(`${this.baseUrl}${this.parkersUrl}/parkernonactiveaccountemailresend`, resendAccountData, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postParkerMassUpdate(parkerMassUpdate: IParkerMassUpdate, lotNumber: string): Observable<IParkerMassUpdate> {
    return this.http
      .post<IParkerMassUpdate>(`${this.baseUrl}${this.parkersUrl}/parkermassupdate/${lotNumber}`, parkerMassUpdate, httpOptions)
      .pipe(catchError(this.handleError));
  }

  PostParkerImport(parkerImportList: IParkerProfileForParkerTable[]): Observable<IParkerProfileImportResult[]> {
    return this.http
      .post<
        IParkerProfileImportResult[]
      >(`${this.baseUrl}${this.parkersUrl}/AddNewParkerProfileImport`, parkerImportList, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      console.error('Error thrown: ' + JSON.stringify(error));
      const errMessage = error.error.message;
      return throwError(() => errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return throwError(() => error || 'server error');
  }

  private prepGetParkersQueryString(queryData: IParkerProfileQuery): string {
    let queryString: string = '';

    try {
      queryString = `lotNumber=${this.encodeQueryStringValue(queryData.lotNumber)}`;

      //companyName
      if (queryData.companyName != 'ALL')
        queryString += `&companyName=${this.encodeQueryStringValue(queryData.companyName)}`;
      else queryString += `&companyName=${this.encodeQueryStringValue('NULL')}`;

      // //firstName
      if (queryData.firstName != '') queryString += `&firstName=${this.encodeQueryStringValue(queryData.firstName)}`;
      else queryString += `&firstName=${this.encodeQueryStringValue('NULL')}`;

      // //lastName
      if (queryData.lastName != '') queryString += `&lastName=${this.encodeQueryStringValue(queryData.lastName)}`;
      else queryString += `&lastName=${this.encodeQueryStringValue('NULL')}`;

      // //cardNumber
      if (queryData.cardNumber != '') queryString += `&cardNumber=${this.encodeQueryStringValue(queryData.cardNumber)}`;
      else queryString += `&cardNumber=${this.encodeQueryStringValue('NULL')}`;

      // //cardNumber
      if (queryData.emailAddress != '')
        queryString += `&emailAddress=${this.encodeQueryStringValue(queryData.emailAddress)}`;
      else queryString += `&emailAddress=${this.encodeQueryStringValue('NULL')}`;

      // //parkerPayType
      queryString += `&parkerPayType=${this.encodeQueryStringValue(queryData.parkerPayType)}`;

      // //invoiceDeliveryMethod
      queryString += `&invoiceDeliveryMethod=${this.encodeQueryStringValue(queryData.invoiceDeliveryMethod)}`;

      // //vehicleLicensePlate
      if (queryData.vehicleLicensePlate !== '')
        queryString += `&vehicleLicensePlate=${this.encodeQueryStringValue(queryData.vehicleLicensePlate)}`;
      else queryString += `&vehicleLicensePlate=${this.encodeQueryStringValue('NULL')}`;

      // //rateNumber
      if (queryData.rateNumber.toUpperCase() !== '0') {
        queryString += `&rateNumber=${this.encodeQueryStringValue(queryData.rateNumber)}`;
      } else queryString += `&rateNumber=${this.encodeQueryStringValue('0')}`;

      // //includeInactive
      if (queryData.includeInactive) queryString += `&includeInactive=${this.encodeQueryStringValue('true')}`;
      else queryString += `&includeInactive=${this.encodeQueryStringValue('false')}`;

      // //isPortalUser
      if (queryData.isPortalUser) queryString += `&isPortalUser=${this.encodeQueryStringValue('true')}`;
      else queryString += `&isPortalUser=${this.encodeQueryStringValue('false')}`;

      // //isAutoPay
      if (queryData.isAutoPay) queryString += `&isAutoPay=${this.encodeQueryStringValue('true')}`;
      else queryString += `&isAutoPay=${this.encodeQueryStringValue('false')}`;

      // //commentsOnly
      if (queryData.commentsOnly) queryString += `&commentsOnly=${this.encodeQueryStringValue('true')}`;
      else queryString += `&commentsOnly=${this.encodeQueryStringValue('false')}`;

      //parkerid
      if (queryData.parkerId !== '') queryString += `&parkerId=${this.encodeQueryStringValue(queryData.parkerId)}`;
      else queryString += `&parkerId=${this.encodeQueryStringValue('NULL')}`;
    } catch (err) {
      console.error('err on parker profile search criteria creation: ' + JSON.stringify(err));
    }

    'query string: ' + queryString;

    return queryString;
  }

  private encodeQueryStringValue(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue: string = String(value);
    const hasCharsToEncode: boolean = /[^A-Za-z0-9\-_.~]/.test(stringValue);

    if (!hasCharsToEncode) {
      return stringValue;
    }

    return encodeURIComponent(stringValue);
  }

  private PrepGetCompanyQueryString(queryData: ICompanyQueryCriteria): string {
    let queryString: string = '';

    try {
      queryString = `lotNumber=${this.encodeQueryStringValue(queryData.lotNumber)}`;
      //companyName and companyId
      if (queryData.companyId != '') queryString += `&companyId=${this.encodeQueryStringValue(queryData.companyId)}`;
      else queryString += `&companyId=${this.encodeQueryStringValue('NULL')}`;

      if (queryData.emailAddress != '')
        queryString += `&emailAddress=${this.encodeQueryStringValue(queryData.emailAddress)}`;
      else queryString += `&emailAddress=${this.encodeQueryStringValue('NULL')}`;

      // //invoiceDeliveryMethod
      queryString += `&invoiceDeliveryMethod=${this.encodeQueryStringValue(queryData.invoiceDeliveryMethod)}`;

      // //includeInactive
      if (queryData.includeInactive) queryString += `&includeInactive=${this.encodeQueryStringValue('true')}`;
      else queryString += `&includeInactive=${this.encodeQueryStringValue('false')}`;

      // //isPortalUser
      if (queryData.isPortalUser) queryString += `&isPortalUser=${this.encodeQueryStringValue('true')}`;
      else queryString += `&isPortalUser=${this.encodeQueryStringValue('false')}`;

      // //isAutoPay
      if (queryData.isAutoPay) queryString += `&isAutoPay=${this.encodeQueryStringValue('true')}`;
      else queryString += `&isAutoPay=${this.encodeQueryStringValue('false')}`;

      // //commentsOnly
      if (queryData.commentsOnly) queryString += `&commentsOnly=${this.encodeQueryStringValue('true')}`;
      else queryString += `&commentsOnly=${this.encodeQueryStringValue('false')}`;

      if (queryData.hasCompanyRates) queryString += `&hasCompanyRates=${this.encodeQueryStringValue('true')}`;
      else queryString += `&hasCompanyRates=${this.encodeQueryStringValue('false')}`;

      if (queryData.isLeaseOnFile) queryString += `&isLeaseOnFile=${this.encodeQueryStringValue('true')}`;
      else queryString += `&isLeaseOnFile=${this.encodeQueryStringValue('false')}`;
    } catch (err) {
      console.error('err on company profile search criteria creation: ' + JSON.stringify(err));
    }

    return queryString;
  }

  getKeyCardExistsByLotNumberCardNumber_Promise(lotNumber: string, cardNumber: string): Promise<boolean> {
    let canVisit: Promise<boolean> = <Promise<boolean>>this.http
      .get(
        `${this.baseUrl}${this.parkersUrl}/GetKeyCardExistsForLotNumberCardNumber?lotNumber=${lotNumber}&cardNumber=${cardNumber}`,
        httpOptions,
      )
      .toPromise()
      .then((exists: any) => {
        return exists;
      })
      .catch((err) => {});
    return canVisit;
  }

  private PrepInvoiceComplexQuerySearchCriteriaRequest(
    queryValues: ISearchInvoiceDataForComplexInvoiceNotificationRequest,
  ): string {
    let queryString: string = '';

    queryString = `LotNumber=${queryValues.lotNumber}`;

    //Company Name
    if (queryValues.companyName !== '') {
      queryValues.companyName = queryValues.companyName.replace('&', '%26');
      queryString += `&CompanyName=${queryValues.companyName}`;
    }

    //Company Name
    if (queryValues.invoiceType !== '' && queryValues.invoiceType !== 'ALL') {
      queryString += `&InvoiceType=${queryValues.invoiceType}`;
    }

    //Parker (CustomerName)
    if (queryValues.parkerName !== '') {
      queryValues.parkerName = queryValues.parkerName.replace('&', '%26');
      queryString += `&ParkerName=${queryValues.parkerName}`;
    }

    //Invoice Number
    if (queryValues.invoiceNumber !== '') {
      queryString += `&InvoiceNumber=${queryValues.invoiceNumber}`;
    }

    //Customer Type
    if (queryValues.customerType === 'ALL') queryString += `&CustomerType=${''}`;

    if (queryValues.customerType === 'PARKERPAID') queryString += `&CustomerType=${'P'}`;

    if (queryValues.customerType === 'COMPANYPAID') queryString += `&CustomerType=${'C'}`;

    //Revenue Start Date
    if (queryValues.revenueStartDate !== '') {
      queryString += `&RevenueStartDate=${queryValues.revenueStartDate}`;
    }

    //Revenue End Date
    if (queryValues.revenueEndDate !== '') {
      queryString += `&RevenueEndDate=${queryValues.revenueEndDate}`;
    }

    //Transaction Start Date
    if (queryValues.transactionStartDate !== '') {
      queryString += `&TransactionStartDate=${queryValues.transactionStartDate}`;
    }

    //Transaction End Date
    if (queryValues.transactionEndDate !== '') {
      queryString += `&TransactionEndDate=${queryValues.transactionEndDate}`;
    }

    if (queryValues.startDateForQuery !== '') {
      queryString += `&StartDateForQuery=${queryValues.startDateForQuery}`;
    }

    queryString += `&queryType=${queryValues.queryType}`;

    return queryString;
  }
}
